module.exports = __webpack_public_path__ + "img/BuddyStrap.41035e43.svg";